import React, { useMemo } from 'react'

import { HBox, Wrapper } from 'src/ui/layout'
import { Image } from 'src/ui/atoms'
import { styled } from 'src/ui/theme'
import { Body, Header, Label } from 'src/ui/typography'
import { BENEFITS_TOP_BLOCK_DATA } from './constants'

const TopBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 50px;
`

const BenefitsCard = styled.div`
  position: relative;
  width: 100%;
  height: 414px;
  min-width: 404px;
  flex: 1;
`

const StyledImage = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const TextBlock = styled.div`
  width: 80%;
  min-height: 149px;
  padding: 24px 32px 24px 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  position: absolute;
  bottom: 0;
  left: 0;
`

const TextBlockBig = styled.div`
  height: 247px;
  padding: 40px 50px;
  background-color: #ffffff;
  position: absolute;
  bottom: 0;
  right: 0;
`

const BenefitsCardBig = styled.div`
  width: 100%;
  position: relative;
`

const StyledBody = styled(Body)`
  font-size: 14px;
`

const TitleBlock = styled.div`
  width: 100%;
  padding: 64px 0;
`

const BlockTitle = styled.h5`
  font-family: 'Gillroy', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 2%;
`

type Props = {
  images: TImages
}

export const Benefits = ({ images }: Props) => {
  const topBlockData = useMemo(() => BENEFITS_TOP_BLOCK_DATA(images), [images])

  return (
    <Wrapper>
      <TitleBlock>
        <Header size="h2" as="h2">
          Создаем среду для роста и комфорта
        </Header>
      </TitleBlock>

      <TopBlock>
        {topBlockData.map((item, index) => (
          <BenefitsCard key={index}>
            <StyledImage fluid={item.img} />
            <TextBlock>
              <BlockTitle>{item.title}</BlockTitle>
              <StyledBody>{item.body}</StyledBody>
            </TextBlock>
          </BenefitsCard>
        ))}
      </TopBlock>
      <HBox height={56} />
      <BenefitsCardBig>
        <StyledImage fluid={images['benefits4']} />
        <TextBlockBig>
          <Header size="h2" as="h2">
            Рост зарплат на 28,4%
          </Header>
          <HBox height={24} />
          <Header size="h5" as="h5">
            1 млн. рублей в год проактивным сотрудникам из Фонда KODE
          </Header>
          <HBox height={16} />
          <Label>*на фото Финансовый директор KODE</Label>
        </TextBlockBig>
      </BenefitsCardBig>
    </Wrapper>
  )
}
